<script lang="ts">
  // Future TODO: consolidate ButtonWrapper and Button into one component?

  import { clickOutside } from "../../svelte/actions/clickOutside.ts";
  import { crossfade } from "svelte/transition";
  import { quintOut } from "svelte/easing";
  import { fade } from "svelte/transition";

  const [send, receive] = crossfade({
    duration: 500,
    easing: quintOut,
  });

  export let shareData: ShareData | null = null;

  let copyLinkStatus = "";
  let showFallbackSharing = false;

  async function copyLink(url: string) {
    try {
      await navigator.clipboard.writeText(url);
      copyLinkStatus = "Link copied!";
      setTimeout(() => {
        copyLinkStatus = "";
      }, 2000);
    } catch (e) {
      copyLinkStatus = "Failed to copy link";
      console.log(e);
    }
  }

  function hide() {
    showFallbackSharing = false;
    copyLinkStatus = "";
  }
  function show() {
    console.log("clicked");
    showFallbackSharing = true;
  }
</script>

{#if !!shareData}
  <!-- svelte-ignore a11y-no-static-element-interactions-->
  <div
    class="relative"
    role="button"
    tabindex="0"
    on:keydown={show}
    aria-label="Share"
    use:clickOutside
    on:outsideclick={hide}
    on:click={show}
  >
    <slot />
    {#if showFallbackSharing && shareData.url}
      <div
        class="p-4 rounded-md text-left bg-white absolute bottom-0 left-0 translate-y-full"
      >
        <a
          class="block text-black text-body-small"
          href={`https://x.com/intent/post?text=${shareData.text}&url=${shareData.url}`}
          target="_blank">Share on X</a
        >
        <a
          class="block text-black text-body-small"
          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareData.url)}`}
          target="_blank">Share on Facebook</a
        >
        <div class="grid">
          {#if copyLinkStatus}
            <p
              class=" row-start-1 row-end-1 col-start-1 col-end-1 text-black text-body-small"
              in:fade={{ duration: 500 }}
              out:fade={{ duration: 100 }}
            >
              {copyLinkStatus}
            </p>
          {:else}
            <button
              in:fade={{ duration: 500 }}
              out:fade={{ duration: 100 }}
              on:click={() => {
                if (!shareData?.url) return;
                copyLink(shareData.url);
              }}
              class=" text-left row-start-1 row-end-1 col-start-1 col-end-1 hover:text-p300 text-black text-body-small"
              >Copy Link</button
            >
          {/if}
        </div>
      </div>
    {/if}
  </div>
{:else}
  <slot />
{/if}
